import React from 'react';
import Description from '../components/Description';
import ScrollToTop from '../components/ScrollToTop';

const DescriptionPage = () => {
    return (
        <>
            <ScrollToTop />
            <Description/>
        </>
    );
};

export default DescriptionPage;